import React from "react";
import { NavLink, useResolvedPath } from "react-router-dom";
import { NavItem } from "react-bootstrap";
import { isPathAllowed } from "../../utils/Common";
import { Link } from 'react-router-dom'; 

export default function PrivateLink(props) {
  const to = props.to;
  const path = useResolvedPath(to);
  const isAllowed = isPathAllowed(path.pathname);

  if (isAllowed) {
    return (
      // <NavItem className='navst nav-item-home'>
      //       <Link to="/dashboard" className="text-white text-decoration-none">Home</Link>
      //       <div className="submenu">
      //         <NavItem className='navst'>
      //         <NavLink {...props} />
      //         </NavItem>
              
      //       </div>
      //     </NavItem>
      <li className="nav-item">
          <NavLink {...props} />
        </li>
      // <NavItem className="navst">
      //   <NavLink {...props} />
      // </NavItem>
    );
  } else return;
 
}
